import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';

import { Route, useNavigate,useMatch, useParams } from "react-router-dom";
import { decryptdata } from "../utils/crypto";
const ProtectedRoute = (props) => {
    const navigate = useNavigate();
    const {id,name}=useParams()
    const planRouteMatch=useMatch('package/plan/:id')
    const shopPlanRouteMatch=useMatch('package/planAddons/:id')
    const mdsNotes=useMatch('package/:name')
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    // const showToastError = (message) => {
    //     toast.error(message);
    //   };
    const checkUserToken = () => {
        const userToken = decryptdata(localStorage.getItem('token'));
        if (!userToken || userToken === undefined) {
            setIsLoggedIn(false);
            if(planRouteMatch){
                return navigate(`/onboarding/login?plan=${id}`);
            }
            else if(shopPlanRouteMatch){
                return navigate(`/onboarding/login?shop=${id}`);
            }
            else if(mdsNotes){
                return navigate(`/onboarding/login?notes=${name}`);
            }
            else{
                return navigate('/onboarding/login');
            }
        }
        setIsLoggedIn(true);
    }
    useEffect(() => {
            checkUserToken();
        }, [isLoggedIn]);
    return (
        <React.Fragment>
            {
                isLoggedIn ? props.children : null
            }
        </React.Fragment>
    );
}
export default ProtectedRoute;